import React from 'react';
import { FiInfo, FiTrash2 } from 'react-icons/fi';
import SimpleTextarea from 'src/components/SimpleTextarea';
import SimpleSelect from 'src/components/SimpleSelect';
import TitleInput from 'src/components/TitleInput';
import PropTypes from 'prop-types';
import Switcher from 'src/components/Switcher';
import { Tooltip } from 'src/components/Tooltip/style';
import {
  IntentArgumentActions,
  IntentArgumentWrapper,
  IntentField,
  IntentFieldGroup
} from './style';
import IntentTypeChoices, { getDefaultMultipleChoiceData } from './IntentTypeChoices';
import { argumentTypes } from './config';

const getDefaultArgumentTypeData = type => {
  if (type === 'multiple') {
    return [getDefaultMultipleChoiceData()];
  }
  return null;
};

export default function IntentArgument({ onRemove, data, onChange }) {
  return (
    <IntentArgumentWrapper>
      <IntentFieldGroup>
        <IntentField>
          <TitleInput
            fontSize={18}
            maxWidth={420}
            value={data.name}
            onChange={e => {
              onChange({ ...data, name: e.target.value });
            }}
            placeholder="Name of the form field"
          />
          <IntentArgumentActions>
            <button type="button" onClick={onRemove}>
              <FiTrash2 />
            </button>
          </IntentArgumentActions>
        </IntentField>
        <IntentField>
          <p>
            Description &nbsp; <FiInfo size={16} data-tip data-for="argument-description-tooltip" />
          </p>
          <SimpleTextarea
            value={data.description}
            onChange={e => {
              onChange({ ...data, description: e.target.value });
            }}
            placeholder="Description of the form field"
          />
          <Tooltip place="right" maxWidth={276} id="argument-description-tooltip" effect="solid">
            Describe what the agent should ask the contact. You can use this as a prompt to explain
            how it should behave in certain scenarios.
          </Tooltip>
        </IntentField>
        <IntentField>
          <p>Type</p>
          <SimpleSelect
            placeholder="Type of the form field"
            value={data.type}
            onChange={value => {
              onChange({
                ...data,
                type: value,
                type_data: getDefaultArgumentTypeData(value.value)
              });
            }}
            options={argumentTypes}
          />
        </IntentField>
        {data.type?.value === 'multiple' && (
          <IntentTypeChoices
            data={data.type_data}
            onChange={newdata => {
              onChange({
                ...data,
                type_data: newdata
              });
            }}
          />
        )}
        <IntentField>
          <p>Required</p>
          <Switcher
            width={50}
            checked={!!data.is_required}
            controlText={{ checked: '', unchecked: '' }}
            onChange={() => {
              onChange({ ...data, is_required: !data.is_required });
            }}
          />
        </IntentField>
      </IntentFieldGroup>
    </IntentArgumentWrapper>
  );
}

IntentArgument.propTypes = {
  onRemove: PropTypes.func.isRequired,
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
    type: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }),
    description: PropTypes.string.isRequired,
    is_required: PropTypes.bool,
    type_data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.string
      })
    )
  }).isRequired,
  onChange: PropTypes.func.isRequired
};
